export const getModalConfig = (closeHandler, closeFromOverlay) => ({
    className: "rj-reality-check-popup",
    isInIframe: false,
    hasOverlay: true,
    closeFromOverlay,
    afterHideCallback: closeHandler
});
//# sourceMappingURL=getModalConfig.js.map